import { InstagramChrome } from './InstagramChrome'
import { ChromeProps } from './Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { XChrome } from './XChrome'
import { LinkedinChrome } from './LinkedinChrome'
import { FacebookChrome } from './FacebookChrome'

export const Chrome = ({ channel, caption, children, integration }: ChromeProps) => {
  switch (channel) {
    case DesignChannel.InstagramPost:
      return (
        <InstagramChrome caption={caption} integration={integration}>
          {children}
        </InstagramChrome>
      )
    case DesignChannel.FacebookPost:
      return (
        <FacebookChrome caption={caption} integration={integration}>
          {children}
        </FacebookChrome>
      )
    case DesignChannel.TwitterPost:
      return (
        <XChrome caption={caption} integration={integration}>
          {children}
        </XChrome>
      )
    case DesignChannel.LinkedInPost:
      return (
        <LinkedinChrome caption={caption} integration={integration}>
          {children}
        </LinkedinChrome>
      )
    default:
      return <div style={{ flex: 1, borderRadius: 15, overflow: 'hidden' }}>{children}</div>
  }
}
